import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-a.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-a.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { Validators } from "@angular/forms";
import { CreateApplicationDetailsAConstants } from "./create-application-details-a.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { LookupConstants } from "../../../../shared/constants/lookup.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { phoneNumberValidator } from "../../../../shared/classes/phone-number-validator";
import { RecipientSelectComponent } from "../../../../shared/components/recipient-components/recipient-select/recipient-select.component";
let CreateApplicationDetailsAComponent = class CreateApplicationDetailsAComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    searchApplicationsService;
    detailsForm;
    personResponsibleComponentRef;
    advertisementFormGroup;
    advertisementsFormGroupName = CreateApplicationDetailsAConstants.ADVERTISEMENTS_FORM_GROUP_NAME;
    validationMessages = CreateApplicationDetailsAConstants.VALIDATION_MESSAGES;
    applicationDetailsFormGroupName = CreateApplicationDetailsAConstants.APPLICATION_DETAILS_FORM_GROUP_NAME;
    // FormControls
    detailsFormGroupName = CreateApplicationDetailsAConstants.DETAILS_FORM_GROUP_NAME;
    descriptionFormControlName = CreateApplicationDetailsAConstants.DESCRIPTION_FORM_CONTROL_NAME;
    isAdvertisementPermanentOrTemporaryFormControlName = CreateApplicationDetailsAConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsAConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    displayStartDateControlName = CreateApplicationDetailsAConstants.DISPLAY_START_DATE_FORM_CONTROL_NAME;
    displayEndDateControlName = CreateApplicationDetailsAConstants.DISPLAY_END_DATE_FORM_CONTROL_NAME;
    displayRemovalDateControlName = CreateApplicationDetailsAConstants.DISPLAY_REMOVAL_DATE_FORM_CONTROL_NAME;
    numberOfPostersControlName = CreateApplicationDetailsAConstants.NUMBER_OF_POSTERS_FORM_CONTROL_NAME;
    nameOfBusinessControlName = CreateApplicationDetailsAConstants.NAME_OF_BUSINESS_FORM_CONTROL_NAME;
    notifySignageRemovalPeriodControlName = CreateApplicationDetailsAConstants.NOTIFY_SIGNAGE_REMOVAL_PERIOD_FORM_CONTROL_NAME;
    positionOfTheDisplayControlName = CreateApplicationDetailsAConstants.POSITION_OF_DISPLAY_FORM_CONTROL_NAME;
    heightControlName = CreateApplicationDetailsAConstants.HEIGHT_FORM_CONTROL_NAME;
    widthControlName = CreateApplicationDetailsAConstants.WIDTH_FORM_CONTROL_NAME;
    depthControlName = CreateApplicationDetailsAConstants.DEPTH_FORM_CONTROL_NAME;
    materialControlName = CreateApplicationDetailsAConstants.MATERIAL_FORM_CONTROL_NAME;
    coloursControlName = CreateApplicationDetailsAConstants.COLOURS_FORM_CONTROL_NAME;
    frontalAreaControlName = CreateApplicationDetailsAConstants.FRONTAL_AREA_FORM_CONTROL_NAME;
    totalAreaControlName = CreateApplicationDetailsAConstants.TOTAL_AREA_FORM_CONTROL_NAME;
    signTypeControlName = CreateApplicationDetailsAConstants.SIGN_TYPE_FORM_CONTROL_NAME;
    weightControlName = CreateApplicationDetailsAConstants.WEIGHT_FORM_CONTROL_NAME;
    wattageControlName = CreateApplicationDetailsAConstants.WATTAGE_FORM_CONTROL_NAME;
    signContractorControlName = CreateApplicationDetailsAConstants.SIGN_CONTRACTOR_NAME_FORM_CONTROL_NAME;
    signContractorAddressControlName = CreateApplicationDetailsAConstants.SIGN_CONTRACTOR_ADDRESS_FORM_CONTROL_NAME;
    signContractorTelephoneControlName = CreateApplicationDetailsAConstants.SIGN_CONTRACTOR_TELEPHONE_FORM_CONTROL_NAME;
    forSaleControlName = CreateApplicationDetailsAConstants.FOR_SALE_FORM_CONTROL_NAME;
    onShowControlName = CreateApplicationDetailsAConstants.ON_SHOW_FORM_CONTROL_NAME;
    toLetControlName = CreateApplicationDetailsAConstants.TO_LET_FORM_CONTROL_NAME;
    soldControlName = CreateApplicationDetailsAConstants.SOLD_FORM_CONTROL_NAME;
    OtherControlName = CreateApplicationDetailsAConstants.OTHER_FORM_CONTROL_NAME;
    constructionBoardSignControlName = CreateApplicationDetailsAConstants.CONSTRUCTION_BOARD_SIGN_FORM_CONTROL_NAME;
    groundSignControlName = CreateApplicationDetailsAConstants.GROUND_SIGN_FORM_CONTROL_NAME;
    flagControlName = CreateApplicationDetailsAConstants.FLAG_FORM_CONTROL_NAME;
    sandwichBoardControlName = CreateApplicationDetailsAConstants.SANDWICH_BOARD_FORM_CONTROL_NAME;
    pylonControlName = CreateApplicationDetailsAConstants.PYLON_FORM_CONTROL_NAME;
    wallSignControlName = CreateApplicationDetailsAConstants.WALL_SIGN_FORM_CONTROL_NAME;
    billBoardControlName = CreateApplicationDetailsAConstants.BILLBOARD_FORM_CONTROL_NAME;
    buildingAttachmentControlName = CreateApplicationDetailsAConstants.BUILDING_ATTACHMENT_FORM_CONTROL_NAME;
    projectingWallControlName = CreateApplicationDetailsAConstants.PROJECTING_WALL_SIGN_FORM_CONTROL_NAME;
    wallPaintedControlName = CreateApplicationDetailsAConstants.WALL_PAINTED_FORM_CONTROL_NAME;
    roofSignControlName = CreateApplicationDetailsAConstants.ROOF_SIGN_FORM_CONTROL_NAME;
    skySignControlName = CreateApplicationDetailsAConstants.SKY_SIGN_FORM_CONTROL_NAME;
    verandaControlName = CreateApplicationDetailsAConstants.VERANDA_FORM_CONTROL_NAME;
    aerialSignControlName = CreateApplicationDetailsAConstants.AERIAL_SIGN_FORM_CONTROL_NAME;
    windowSignControlName = CreateApplicationDetailsAConstants.WINDOW_SIGN_FORM_CONTROL_NAME;
    schoolSignControlName = CreateApplicationDetailsAConstants.SCHOOL_SIGN_FORM_CONTROL_NAME;
    combinationSignControlName = CreateApplicationDetailsAConstants.COMBINATION_SIGN_FORM_CONTROL_NAME;
    underAwningSignControlName = CreateApplicationDetailsAConstants.UNDER_AWNING_SIGN_FORM_CONTROL_NAME;
    flagSignControlName = CreateApplicationDetailsAConstants.FLAG_SIGN_FORM_CONTROL_NAME;
    canopyControlName = CreateApplicationDetailsAConstants.CANOPY_FORM_CONTROL_NAME;
    balconyControlName = CreateApplicationDetailsAConstants.BALCONY_FORM_CONTROL_NAME;
    electronicSignControlName = CreateApplicationDetailsAConstants.ELECTRONIC_SIGN_FORM_CONTROL_NAME;
    developmentBoardControlName = CreateApplicationDetailsAConstants.DEVELOPMENT_BOARD_FORM_CONTROL_NAME;
    otherFiveYearControlName = CreateApplicationDetailsAConstants.OTHER_FIVE_YEAR_FORM_CONTROL_NAME;
    nonIlluminatedBillboardControlName = CreateApplicationDetailsAConstants.NON_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME;
    digitalBillboardControlName = CreateApplicationDetailsAConstants.DIGITAL_BILLBOARD_FORM_CONTROL_NAME;
    nonIlluminatedGantryControlName = CreateApplicationDetailsAConstants.NON_ILLUMINATED_GANTRY_FORM_CONTROL_NAME;
    digitalGantryControlName = CreateApplicationDetailsAConstants.DIGITAL_GANTRY_FORM_CONTROL_NAME;
    internallyIlluminatedBillboardControlName = CreateApplicationDetailsAConstants.INTERNALLY_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME;
    internallyIlluminatedGantryControlName = CreateApplicationDetailsAConstants.INTERNALLY_ILLUMINATED_GANTRY_FORM_CONTROL_NAME;
    municipalConsumerAccountNumberFormControlName = CreateApplicationDetailsAConstants.MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_CONTROL_NAME;
    personResponsibleFormControlName = CreateApplicationDetailsAConstants.PERSON_RESPONSIBLE_CONTROL_NAME;
    // Labels
    descriptionLabel = CreateApplicationDetailsAConstants.DESCRIPTION_LABEL;
    typeLabel = CreateApplicationDetailsAConstants.APPLICATION_TYPE_LABEL;
    displayStartDateLabel = CreateApplicationDetailsAConstants.DISPLAY_START_DATE_LABEL;
    displayEndDateLabel = CreateApplicationDetailsAConstants.DISPLAY_END_DATE_LABEL;
    displayRemovalDateLabel = CreateApplicationDetailsAConstants.DISPLAY_REMOVAL_DATE_LABEL;
    numberOfPostersLabel = CreateApplicationDetailsAConstants.NUMBER_OF_POSTERS_LABEL;
    nameOfBusinessLabel = CreateApplicationDetailsAConstants.NAME_OF_BUSINESS_LABEL;
    notifySignageRemovalPeriodLabel = CreateApplicationDetailsAConstants.NOTIFY_SIGNAGE_REMOVAL_LABEL;
    positionOfTheDisplayLabel = CreateApplicationDetailsAConstants.POSITION_OF_THE_DISPLAY_LABEL;
    heightLabel = CreateApplicationDetailsAConstants.HEIGHT_LABEL;
    widthLabel = CreateApplicationDetailsAConstants.WIDTH_LABEL;
    depthLabel = CreateApplicationDetailsAConstants.DEPTH_LABEL;
    materialLabel = CreateApplicationDetailsAConstants.MATERIAL_LABEL;
    coloursLabel = CreateApplicationDetailsAConstants.COLOURS_LABEL;
    frontalAreaLabel = CreateApplicationDetailsAConstants.FRONTAL_AREA_LABEL;
    totalAreaLabel = CreateApplicationDetailsAConstants.TOTAL_AREA_LABEL;
    signTypeLabel = CreateApplicationDetailsAConstants.SIGN_TYPE_LABEL;
    weightLabel = CreateApplicationDetailsAConstants.WEIGHT_LABEL;
    wattageLabel = CreateApplicationDetailsAConstants.WATTAGE_LABEL;
    signContractorLabel = CreateApplicationDetailsAConstants.SIGN_CONTRACTOR_LABEL;
    signContractorAddressLabel = CreateApplicationDetailsAConstants.SIGN_CONTRACTOR_ADDRESS_LABEL;
    signContractorTelephoneLabel = CreateApplicationDetailsAConstants.SIGN_CONTRACTOR_TELEPHONE_LABEL;
    forSaleAddressLabel = CreateApplicationDetailsAConstants.FOR_SALE_LABEL;
    // 1 year permanent
    onShowLabel = CreateApplicationDetailsAConstants.ON_SHOW_LABEL;
    toLetLabel = CreateApplicationDetailsAConstants.TO_LET_LABEL;
    soldLabel = CreateApplicationDetailsAConstants.SOLD_LABEL;
    constructionBoardSignLabel = CreateApplicationDetailsAConstants.CONSTRUCTION_BOARD_SIGN_LABEL;
    otherLabel = CreateApplicationDetailsAConstants.OTHER_LABEL;
    // 5 year permanent
    groundSignLabel = CreateApplicationDetailsAConstants.GROUND_SIGN_FORM_LABEL;
    flagLabel = CreateApplicationDetailsAConstants.FLAG_FORM_LABEL;
    sandwichBoardLabel = CreateApplicationDetailsAConstants.SANDWICH_BOARD_FORM_LABEL;
    pylonLabel = CreateApplicationDetailsAConstants.PYLON_FORM_LABEL;
    wallSignLabel = CreateApplicationDetailsAConstants.WALL_SIGN_FORM_LABEL;
    billBoardLabel = CreateApplicationDetailsAConstants.BILLBOARD_FORM_LABEL;
    buildingAttachmentLabel = CreateApplicationDetailsAConstants.BUILDING_ATTACHMENT_LABEL;
    projectingWallLabel = CreateApplicationDetailsAConstants.PROJECTING_WALL_SIGN_LABEL;
    wallPaintedLabel = CreateApplicationDetailsAConstants.WALL_PAINTED_LABEL;
    roofSignLabel = CreateApplicationDetailsAConstants.ROOF_SIGN_LABEL;
    skySignLabel = CreateApplicationDetailsAConstants.SKY_SIGN_LABEL;
    verandaLabel = CreateApplicationDetailsAConstants.VERANDA_LABEL;
    aerialSignLabel = CreateApplicationDetailsAConstants.AERIAL_SIGN_LABEL;
    windowSignLabel = CreateApplicationDetailsAConstants.WINDOW_SIGN_LABEL;
    schoolSignLabel = CreateApplicationDetailsAConstants.SCHOOL_SIGN_LABEL;
    combinationSignLabel = CreateApplicationDetailsAConstants.COMBINATION_SIGN_LABEL;
    underAwningSignLabel = CreateApplicationDetailsAConstants.UNDER_AWNING_SIGN_LABEL;
    flagSignLabel = CreateApplicationDetailsAConstants.FLAG_SIGN_LABEL;
    canopyLabel = CreateApplicationDetailsAConstants.CANOPY_LABEL;
    balconyLabel = CreateApplicationDetailsAConstants.BALCONY_LABEL;
    electronicSignLabel = CreateApplicationDetailsAConstants.ELECTRONIC_SIGN_LABEL;
    developmentBoardLabel = CreateApplicationDetailsAConstants.DEVELOPMENT_BOARD_LABEL;
    otherFiveYearLabel = CreateApplicationDetailsAConstants.OTHER_FIVE_YEAR_LABEL;
    nonIlluminatedBillboardLabel = CreateApplicationDetailsAConstants.NON_ILLUMINATED_BILLBOARD_LABEL;
    digitalBillboardLabel = CreateApplicationDetailsAConstants.DIGITAL_BILLBOARD_LABEL;
    nonIlluminatedGantryLabel = CreateApplicationDetailsAConstants.NON_ILLUMINATED_GANTRY_LABEL;
    digitalGantryLabel = CreateApplicationDetailsAConstants.DIGITAL_GANTRY_LABEL;
    internallyIlluminatedBillboardLabel = CreateApplicationDetailsAConstants.INTERNALLY_ILLUMINATED_BILLBOARD_LABEL;
    internallyIlluminatedGantryLabel = CreateApplicationDetailsAConstants.INTERNALLY_ILLUMINATED_GANTRY_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    municipalConsumerAccountNumberLabel = CreateApplicationDetailsAConstants.MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_LABEL;
    personResponsibleLabel = CreateApplicationDetailsAConstants.PERSON_RESPONSIBLE_CONTROL_LABEL;
    // Lookups
    applicationTypesLookups = [];
    signTypeLookups = [];
    removalPeriodLookups = LookupConstants.REMOVAL_PERIOD_LOOKUPS_A;
    nonIlluminatedBillboardLookups = LookupConstants.NON_ILLUMINATED_BILLBOARD_A;
    nonIlluminatedGantryLookups = LookupConstants.NON_ILLUMINATED_GANTRY_A;
    internallyIlluminatedBillboardLookups = LookupConstants.INTERNALLY_ILLUMINATED_BILLBOARD_LOOKUPS_A;
    digitalGantryLookups = LookupConstants.DIGITAL_GANTRY_A;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    notApplicablePlaceholderMessage = SharedConstants.NOT_APPLICABLE_MESSAGE;
    showTemporaryApplicationFields = false;
    showPermanentApplicationFields = false;
    show5YearPermanentApplicationOptionalFields = false;
    show1YearPermanentApplicationOptionalFields = false;
    // person responsible recipient
    personResponsibleDisableEditing = false;
    personResponsibleDisableFilterBy = true;
    personResponsibleGroups = [];
    personResponsibleShowFields = true;
    temporaryApplicationType = [];
    permanentApplicationType = [];
    getLookupsObservableSubscription;
    markStepFormGroupAsTouchedSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        if (this.aflaModuleStrategyService.lookups.has(this.signTypeControlName)) {
            this.signTypeLookups = this.aflaModuleStrategyService.lookups.get(this.signTypeControlName);
            if (!this.aflaModuleStrategyService.form.pristine && this.aflaModuleStrategyService.form.touched) {
                this.checkIfFormWasPreviouslyCompleted();
            }
            else {
                this.setForms();
            }
        }
        else {
            this.getLookups();
        }
        this.subscribeToCheckFormValidity();
    }
    loadMetadata(stepMeta) {
        try {
            this.personResponsibleGroups = stepMeta.personResponsibleGroup;
            this.changeDetectorRef.detectChanges();
        }
        catch (e) {
            this.appControllerService.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    setForms() {
        const advertisementType = this.advertisementFormGroup.get(this.isAdvertisementPermanentOrTemporaryFormControlName).value;
        if (advertisementType) {
            this.handleAdvertisementTypeValueChanged(advertisementType);
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                const lookups = response.value;
                if (lookups.length > 0) {
                    this.getLookupCompleted(lookups);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsAConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    getLookupCompleted(lookups) {
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "signtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.signTypeLookups.push(lookUpContent);
            }
        });
        if (this.aflaModuleStrategyService.form.pristine && !this.aflaModuleStrategyService.form.touched) {
            this.checkIfFormWasPreviouslyCompleted();
        }
        else {
            this.setForms();
        }
        this.changeDetectorRef.detectChanges();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.applicationDetailsFormGroupName);
        this.detailsForm.enable();
        this.advertisementFormGroup = this.aflaModuleStrategyService.form.get(this.advertisementsFormGroupName);
    }
    handleTemporaryAdvertisementSelected() {
        this.hidePermanentAdvertisementTypeFields();
        this.showTemporaryApplicationTypeFields();
    }
    showTemporaryApplicationTypeFields() {
        this.showTemporaryApplicationFields = true;
        this.showPermanentApplicationFields = false;
    }
    handlePermanentAdvertisementSelected() {
        const applicationType = this.advertisementFormGroup.get(this.applicationTypeFormControlName).value;
        this.clearTemporaryAdvertisementFieldsValidators();
        this.resetTemporaryAdvertisementFields();
        this.hideTemporaryAdvertisementFields();
        this.showPermanentAdvertisementFields();
        if (applicationType.toLowerCase().includes("1 year")) {
            this.show1YearPermanentApplicationFields();
        }
        if (applicationType.toLowerCase().includes("5 year")) {
            this.show5YearPermanentApplicationFields();
            this.add5YearApplicationFieldsValidators();
        }
        this.addMainPermanentFieldsValidators();
    }
    showPermanentAdvertisementFields() {
        this.showPermanentApplicationFields = true;
        this.showTemporaryApplicationFields = false;
    }
    hidePermanentAdvertisementTypeFields() {
        this.showPermanentApplicationFields = false;
    }
    hideTemporaryAdvertisementFields() {
        this.showTemporaryApplicationFields = false;
    }
    clearTemporaryAdvertisementFieldsValidators() {
        this.detailsForm.get(this.displayStartDateControlName).clearValidators();
        this.detailsForm.get(this.displayEndDateControlName).clearValidators();
        this.detailsForm.get(this.displayRemovalDateControlName).clearValidators();
        this.detailsForm.get(this.numberOfPostersControlName).clearValidators();
        this.detailsForm.updateValueAndValidity();
    }
    resetTemporaryAdvertisementFields() {
        this.detailsForm.get(this.displayStartDateControlName).reset();
        this.detailsForm.get(this.displayEndDateControlName).reset();
        this.detailsForm.get(this.displayRemovalDateControlName).reset();
        this.detailsForm.get(this.numberOfPostersControlName).reset();
        this.detailsForm.updateValueAndValidity();
    }
    reset5YearPermanentApplicationFields() {
        this.detailsForm.get(this.groundSignControlName).reset(false);
        this.detailsForm.get(this.flagControlName).reset(false);
        this.detailsForm.get(this.sandwichBoardControlName).reset(false);
        this.detailsForm.get(this.pylonControlName).reset(false);
        this.detailsForm.get(this.wallSignControlName).reset(false);
        this.detailsForm.get(this.billBoardControlName).reset(false);
        this.detailsForm.get(this.buildingAttachmentControlName).reset(false);
        this.detailsForm.get(this.projectingWallControlName).reset(false);
        this.detailsForm.get(this.wallPaintedControlName).reset(false);
        this.detailsForm.get(this.roofSignControlName).reset(false);
        this.detailsForm.get(this.skySignControlName).reset(false);
        this.detailsForm.get(this.verandaControlName).reset(false);
        this.detailsForm.get(this.aerialSignControlName).reset(false);
        this.detailsForm.get(this.windowSignControlName).reset(false);
        this.detailsForm.get(this.schoolSignControlName).reset(false);
        this.detailsForm.get(this.combinationSignControlName).reset(false);
        this.detailsForm.get(this.underAwningSignControlName).reset(false);
        this.detailsForm.get(this.flagSignControlName).reset(false);
        this.detailsForm.get(this.canopyControlName).reset(false);
        this.detailsForm.get(this.balconyControlName).reset(false);
        this.detailsForm.get(this.electronicSignControlName).reset(false);
        this.detailsForm.get(this.developmentBoardControlName).reset(false);
        this.detailsForm.get(this.otherFiveYearControlName).reset();
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).reset();
        this.detailsForm.get(this.digitalBillboardControlName).reset();
        this.detailsForm.get(this.nonIlluminatedGantryControlName).reset();
        this.detailsForm.get(this.digitalGantryControlName).reset();
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).reset();
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).reset();
        this.detailsForm.updateValueAndValidity();
    }
    add5YearApplicationFieldsValidators() {
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).addValidators(Validators.required);
        this.detailsForm.get(this.digitalBillboardControlName).addValidators(Validators.required);
        this.detailsForm.get(this.nonIlluminatedGantryControlName).addValidators(Validators.required);
        this.detailsForm.get(this.digitalGantryControlName).addValidators(Validators.required);
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).addValidators(Validators.required);
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).addValidators(Validators.required);
        this.detailsForm.updateValueAndValidity();
    }
    set5YearApplicationFieldsFormValues() {
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).setValue(this.selectedApplication.nonIlluminatedBillboard);
        this.detailsForm.get(this.digitalBillboardControlName).setValue(this.selectedApplication.digitalBillboard);
        this.detailsForm.get(this.nonIlluminatedGantryControlName).setValue(this.selectedApplication.nonIlluminatedGantry);
        this.detailsForm.get(this.digitalGantryControlName).setValue(this.selectedApplication.digitalGantry);
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).setValue(this.selectedApplication.internallyIlluminatedBillboard);
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).setValue(this.selectedApplication.internallyIlluminatedGantry);
        this.detailsForm.updateValueAndValidity();
    }
    reset1yearPermanentApplicationFields() {
        this.detailsForm.get(this.forSaleControlName).reset(false);
        this.detailsForm.get(this.onShowControlName).reset(false);
        this.detailsForm.get(this.toLetControlName).reset(false);
        this.detailsForm.get(this.soldControlName).reset(false);
        this.detailsForm.get(this.constructionBoardSignControlName).reset(false);
        this.detailsForm.get(this.OtherControlName).reset();
        this.detailsForm.updateValueAndValidity();
    }
    removeValidatorsToMainPermanentFields() {
        this.detailsForm.get(this.nameOfBusinessControlName).clearValidators();
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).clearValidators();
        this.detailsForm.get(this.positionOfTheDisplayControlName).clearValidators();
        this.detailsForm.get(this.heightControlName).clearValidators();
        this.detailsForm.get(this.widthControlName).clearValidators();
        this.detailsForm.get(this.depthControlName).clearValidators();
        this.detailsForm.get(this.materialControlName).clearValidators();
        this.detailsForm.get(this.coloursControlName).clearValidators();
        this.detailsForm.get(this.frontalAreaControlName).clearValidators();
        this.detailsForm.get(this.totalAreaControlName).clearValidators();
        this.detailsForm.get(this.signTypeControlName).clearValidators();
        this.detailsForm.get(this.weightControlName).clearValidators();
        this.detailsForm.get(this.wattageControlName).clearValidators();
        this.detailsForm.get(this.signContractorControlName).clearValidators();
        this.detailsForm.get(this.signContractorAddressControlName).clearValidators();
        this.detailsForm.get(this.signContractorTelephoneControlName).clearValidators();
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).clearValidators();
        this.detailsForm.updateValueAndValidity();
    }
    setPermanentAdvertisementFormValues() {
        const personResponsible = this.selectedApplication.personResponsible[0];
        this.detailsForm.get(this.nameOfBusinessControlName).setValue(this.selectedApplication.nameOfBusiness);
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).setValue(this.selectedApplication.notifySignageRemovalPeriod);
        this.detailsForm.get(this.positionOfTheDisplayControlName).setValue(this.selectedApplication.positionOfDisplay);
        this.detailsForm.get(this.heightControlName).setValue(this.selectedApplication.dimensionsH);
        this.detailsForm.get(this.widthControlName).setValue(this.selectedApplication.dimensionsW);
        this.detailsForm.get(this.depthControlName).setValue(this.selectedApplication.dimensionsD);
        this.detailsForm.get(this.materialControlName).setValue(this.selectedApplication.material);
        this.detailsForm.get(this.coloursControlName).setValue(this.selectedApplication.colours);
        this.detailsForm.get(this.frontalAreaControlName).setValue(this.selectedApplication.frontalArea);
        this.detailsForm.get(this.totalAreaControlName).setValue(this.selectedApplication.totalArea);
        this.detailsForm.get(this.signTypeControlName).setValue(this.selectedApplication.signType);
        this.detailsForm.get(this.weightControlName).setValue(this.selectedApplication.weight);
        this.detailsForm.get(this.wattageControlName).setValue(this.selectedApplication.wattage);
        this.detailsForm.get(this.signContractorControlName).setValue(this.selectedApplication.contractorName);
        this.detailsForm.get(this.signContractorAddressControlName).setValue(this.selectedApplication.contractorAddress);
        this.detailsForm.get(this.signContractorTelephoneControlName).setValue(this.selectedApplication.contractorTelephone);
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).setValue(this.selectedApplication.municipalConsumerAccountNumber);
        this.detailsForm.get(this.personResponsibleFormControlName).setValue(personResponsible);
        this.detailsForm.updateValueAndValidity();
    }
    resetMainPermanentFields() {
        this.detailsForm.get(this.nameOfBusinessControlName).reset();
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).reset();
        this.detailsForm.get(this.positionOfTheDisplayControlName).reset();
        this.detailsForm.get(this.heightControlName).reset(0);
        this.detailsForm.get(this.widthControlName).reset(0);
        this.detailsForm.get(this.depthControlName).reset(0);
        this.detailsForm.get(this.materialControlName).reset();
        this.detailsForm.get(this.coloursControlName).reset();
        this.detailsForm.get(this.frontalAreaControlName).reset(0);
        this.detailsForm.get(this.totalAreaControlName).reset(0);
        this.detailsForm.get(this.signTypeControlName).reset();
        this.detailsForm.get(this.weightControlName).reset(0);
        this.detailsForm.get(this.wattageControlName).reset(0);
        this.detailsForm.get(this.signContractorControlName).reset();
        this.detailsForm.get(this.signContractorAddressControlName).reset();
        this.detailsForm.get(this.signContractorTelephoneControlName).reset();
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).reset();
        this.detailsForm.updateValueAndValidity();
    }
    addMainPermanentFieldsValidators() {
        this.detailsForm.get(this.nameOfBusinessControlName).addValidators(Validators.required);
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).addValidators(Validators.required);
        this.detailsForm.get(this.positionOfTheDisplayControlName).addValidators(Validators.required);
        this.detailsForm.get(this.heightControlName).addValidators(Validators.required);
        this.detailsForm.get(this.widthControlName).addValidators(Validators.required);
        this.detailsForm.get(this.depthControlName).addValidators(Validators.required);
        this.detailsForm.get(this.materialControlName).addValidators(Validators.required);
        this.detailsForm.get(this.coloursControlName).addValidators(Validators.required);
        this.detailsForm.get(this.frontalAreaControlName).addValidators(Validators.required);
        this.detailsForm.get(this.totalAreaControlName).addValidators(Validators.required);
        this.detailsForm.get(this.signTypeControlName).addValidators(Validators.required);
        this.detailsForm.get(this.weightControlName).addValidators(Validators.required);
        this.detailsForm.get(this.wattageControlName).addValidators(Validators.required);
        this.detailsForm.get(this.signContractorTelephoneControlName).addValidators(phoneNumberValidator);
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).addValidators(Validators.required);
        this.detailsForm.updateValueAndValidity();
    }
    filterApplicationTypeAccordingToSelectedAdvertisementType(advertisementType) {
        if (advertisementType.toLowerCase() === "temporary") {
            this.temporaryApplicationType = [];
            this.applicationTypesLookups.forEach((applicationType) => {
                if (applicationType.value.toLowerCase().includes(advertisementType) || applicationType.value.toLowerCase() === "other")
                    this.temporaryApplicationType.push(applicationType);
            });
            this.temporaryApplicationType.sort((a, b) => {
                return a.value > b.value ? 1 : -1;
            });
        }
        if (advertisementType.toLowerCase() === "permanent") {
            this.permanentApplicationType = [];
            this.applicationTypesLookups.forEach((applicationType) => {
                if (applicationType.value.toLowerCase().includes(advertisementType) || applicationType.value.toLowerCase() === "other")
                    this.permanentApplicationType.push(applicationType);
            });
            this.permanentApplicationType.sort((a, b) => {
                return a.value > b.value ? 1 : -1;
            });
        }
    }
    checkIfFormWasPreviouslyCompleted() {
        if (this.aflaModuleStrategyService.form.pristine && !this.aflaModuleStrategyService.form.touched) {
            const advertisementTypeValue = this.selectedApplication.isAdvetisingPermanentOrTemporary;
            const applicationType = this.selectedApplication.type;
            this.detailsForm.get(this.descriptionFormControlName).setValue(this.selectedApplication.description);
            if (advertisementTypeValue && applicationType) {
                if (advertisementTypeValue === "permanent") {
                    this.setupDefaultFormsForPermanentAdvertisementApplications();
                    if (applicationType.toLowerCase().includes("1 year")) {
                        this.setupDefaultFormsFor1YearPermanentAdvertisementApplications();
                    }
                    if (applicationType.toLowerCase().includes("5 year")) {
                        this.setupDefaultFormsFor5YearPermanentAdvertisementApplications();
                    }
                    this.addMainPermanentFieldsValidators();
                }
                if (advertisementTypeValue === "temporary") {
                    this.setupDefaultFormsForTemporaryAdvertisementApplications();
                }
            }
            this.changeDetectorRef.detectChanges();
        }
    }
    setupDefaultFormsForPermanentAdvertisementApplications() {
        this.resetTemporaryAdvertisementFields();
        this.clearTemporaryAdvertisementFieldsValidators();
        this.hideTemporaryAdvertisementFields();
        this.showPermanentAdvertisementFields();
        this.setPermanentAdvertisementFormValues();
    }
    setupDefaultFormsFor1YearPermanentAdvertisementApplications() {
        this.reset5YearPermanentApplicationFields();
        this.clearValidatorsOn5YearPermanentApplicationFields();
        this.hide5YearPermanentApplicationFields();
        this.show1YearPermanentApplicationFields();
        this.set1YearPermanentApplicationFormValues();
    }
    setupDefaultFormsFor5YearPermanentAdvertisementApplications() {
        this.reset1yearPermanentApplicationFields();
        this.hide1YearPermanentApplicationFields();
        this.show5YearPermanentApplicationFields();
        this.add5YearApplicationFieldsValidators();
        this.set5YearApplicationFieldsFormValues();
    }
    setupDefaultFormsForTemporaryAdvertisementApplications() {
        this.resetAndHidePermanentApplicationFields();
        this.showTemporaryApplicationTypeFields();
        this.addValidatorsToTemporaryFields();
        this.setTemporaryApplicationFormValues();
    }
    handleAdvertisementTypeValueChanged(advertisementType) {
        if (advertisementType.toLowerCase() === "temporary") {
            this.handleTemporaryAdvertisementSelected();
            this.removeValidatorsToMainPermanentFields();
            this.resetMainPermanentFields();
            this.addValidatorsToTemporaryFields();
        }
        if (advertisementType.toLowerCase() === "permanent") {
            this.handlePermanentAdvertisementSelected();
        }
        this.filterApplicationTypeAccordingToSelectedAdvertisementType(advertisementType);
        this.changeDetectorRef.detectChanges();
    }
    addValidatorsToTemporaryFields() {
        this.detailsForm.get(this.displayStartDateControlName).addValidators(Validators.required);
        this.detailsForm.get(this.displayEndDateControlName).addValidators(Validators.required);
        this.detailsForm.get(this.displayRemovalDateControlName).addValidators(Validators.required);
        this.detailsForm.get(this.numberOfPostersControlName).addValidators(Validators.required);
        this.detailsForm.updateValueAndValidity();
    }
    setTemporaryApplicationFormValues() {
        this.detailsForm.get(this.displayStartDateControlName).setValue(this.selectedApplication.displayStartDate);
        this.detailsForm.get(this.displayEndDateControlName).setValue(this.selectedApplication.displayEndDate);
        this.detailsForm.get(this.displayRemovalDateControlName).setValue(this.selectedApplication.displayRemovalDate);
        this.detailsForm.get(this.numberOfPostersControlName).setValue(this.selectedApplication.numberOfPosters);
        this.detailsForm.updateValueAndValidity();
    }
    setNumberToDecimal(control, event, decimalPlace) {
        const value = event.target.value;
        const decimalString = parseFloat(value).toFixed(decimalPlace);
        const decimalValue = parseFloat(decimalString);
        control.setValue(decimalValue);
    }
    hide1YearPermanentApplicationFields() {
        this.show1YearPermanentApplicationOptionalFields = false;
    }
    show1YearPermanentApplicationFields() {
        this.show1YearPermanentApplicationOptionalFields = true;
    }
    hide5YearPermanentApplicationFields() {
        this.show5YearPermanentApplicationOptionalFields = false;
    }
    show5YearPermanentApplicationFields() {
        this.show5YearPermanentApplicationOptionalFields = true;
    }
    hideMainPermanentFields() {
        this.showPermanentApplicationFields = false;
    }
    clearValidatorsOn5YearPermanentApplicationFields() {
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).clearValidators();
        this.detailsForm.get(this.digitalBillboardControlName).clearValidators();
        this.detailsForm.get(this.nonIlluminatedGantryControlName).clearValidators();
        this.detailsForm.get(this.digitalGantryControlName).clearValidators();
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).clearValidators();
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).clearValidators();
        this.detailsForm.updateValueAndValidity();
    }
    resetAndHidePermanentApplicationFields() {
        // reset and hide 1 year permanent fields
        this.reset1yearPermanentApplicationFields();
        this.hide1YearPermanentApplicationFields();
        // reset and hide 5 year permanent fields
        this.clearValidatorsOn5YearPermanentApplicationFields();
        this.reset5YearPermanentApplicationFields();
        this.hide5YearPermanentApplicationFields();
        // reset and hide fields that are common in 5 year and 1 year permanent fields
        this.clearMainPermanentFieldsValidators();
        this.resetMainPermanentFields();
        this.hideMainPermanentFields();
    }
    clearMainPermanentFieldsValidators() {
        this.detailsForm.get(this.nameOfBusinessControlName).clearValidators();
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).clearValidators();
        this.detailsForm.get(this.positionOfTheDisplayControlName).clearValidators();
        this.detailsForm.get(this.heightControlName).clearValidators();
        this.detailsForm.get(this.widthControlName).clearValidators();
        this.detailsForm.get(this.depthControlName).clearValidators();
        this.detailsForm.get(this.materialControlName).clearValidators();
        this.detailsForm.get(this.coloursControlName).clearValidators();
        this.detailsForm.get(this.frontalAreaControlName).clearValidators();
        this.detailsForm.get(this.totalAreaControlName).clearValidators();
        this.detailsForm.get(this.signTypeControlName).clearValidators();
        this.detailsForm.get(this.weightControlName).clearValidators();
        this.detailsForm.get(this.wattageControlName).clearValidators();
        this.detailsForm.get(this.signContractorControlName).clearValidators();
        this.detailsForm.get(this.signContractorAddressControlName).clearValidators();
        this.detailsForm.get(this.signContractorTelephoneControlName).clearValidators();
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).clearValidators();
        this.detailsForm.updateValueAndValidity();
    }
    set1YearPermanentApplicationFormValues() {
        this.detailsForm.get(this.forSaleControlName).setValue(this.selectedApplication.forSale);
        this.detailsForm.get(this.onShowControlName).setValue(this.selectedApplication.onShow);
        this.detailsForm.get(this.toLetControlName).setValue(this.selectedApplication.toLet);
        this.detailsForm.get(this.soldControlName).setValue(this.selectedApplication.sold);
        this.detailsForm.get(this.constructionBoardSignControlName).setValue(this.selectedApplication.constructionBoardSign);
        this.detailsForm.get(this.OtherControlName).setValue(this.selectedApplication.otherOneYear);
        this.detailsForm.updateValueAndValidity();
    }
    subscribeToCheckFormValidity() {
        this.markStepFormGroupAsTouchedSubscription = this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.detailsForm && formGroupName === this.detailsFormGroupName) {
                    this.detailsForm.markAllAsTouched();
                    if (this.showPermanentApplicationFields) {
                        this.personResponsibleComponentRef.markAllAsTouched();
                    }
                    this.changeDetectorRef.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        personResponsibleComponentRef: [{ type: ViewChild, args: [RecipientSelectComponent,] }]
    };
};
CreateApplicationDetailsAComponent = __decorate([
    Component({
        selector: "app-create-application-details-a",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsAComponent);
export { CreateApplicationDetailsAComponent };
